{
  "selectGroup": "Оберіть unit, щоб зареєструватися",
  "empty": "Наразі немає доступних груп для реєстрації.",
  "unavailable": "Посилання недійсне або організація більше не доступна."
}
